import './App.css';
import { Routes, Route } from 'react-router-dom';
import Menu from './componentes/Menu';
import Home from './componentes/Home';
import DetalleProducto from './componentes/Productos/DetalleProducto';
import DetalleReceta from './componentes/Recetas/DetalleReceta'
import Contacto from './componentes/Contacto';
import Formulario from './componentes/Formulario';
import Login  from './componentes/auth/Login';
import SignUp  from './componentes/auth/Signup';
import AuthDetails from './componentes/auth/AuthDetails';
import Footer from './componentes/Footer';
import ContenedorProductos from './componentes/Productos/ContenedorProductos';
import Carrito from './componentes/Carrito/Carrito';
import Crear from './componentes/Carrito/Crear';
import Editar from './componentes/Carrito/Editar';
import CrearProducto from './componentes/Productos/CRUD/Crear';
import EditarProducto from './componentes/Productos/CRUD/Editar';

function App() {
  return (
    <div className="App">
      <Menu />

      <Routes>       

        <Route path='/' element={<Home/>}/>
        <Route path='contacto' element={<Contacto/>}/>
        <Route path='formulario' element={<Formulario/>}/>
        <Route path='login' element={<Login/>}/>
        <Route path='signUp' element={<SignUp/>}/>
        <Route path='authDetails' element={<AuthDetails/>}/>
        <Route path='carrito' element={<Carrito />} />
				<Route path='/crearcarrito' element={<Crear/>}/>
        <Route path='/editarcarrito/:id' element={<Editar/>}/>
        <Route path='productos' element={<ContenedorProductos />}></Route>
        <Route path='producto/:id' element={<DetalleProducto />}></Route>
        <Route path='editar/producto/:id' element={<EditarProducto/>}></Route>
        <Route path='crear/producto/' element={<CrearProducto/>}></Route>
        <Route path='receta/:id' element={<DetalleReceta />}></Route>
        <Route path='contacto' element={<Contacto />} />
        <Route path='formulario' element={<Formulario />} />

      </Routes>
      
      <Footer />


    </div>
  );
}

export default App;
